import React from 'react';
import { useTheme } from '@mui/material/styles';
import { ThemedSvgProps } from '../../types';

const GameControllerBase: React.FC<ThemedSvgProps> = ({ color, size = 60, className }) => {
  const theme = useTheme();
  const fill = color || theme.palette.venue.gaming;
  const highlight = `${fill}66`; // 40% opacity hex

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      role="presentation"
      className={className}
    >
      {/* Controller body */}
      <rect x="15" y="30" width="70" height="40" rx="12" fill={fill} />

      {/* Left grip */}
      <rect x="10" y="45" width="18" height="28" rx="8" fill={fill} />

      {/* Right grip */}
      <rect x="72" y="45" width="18" height="28" rx="8" fill={fill} />

      {/* Left joystick */}
      <circle cx="35" cy="47" r="8" fill={highlight} />
      <circle cx="35" cy="47" r="5" fill={fill} />

      {/* Right joystick */}
      <circle cx="65" cy="55" r="8" fill={highlight} />
      <circle cx="65" cy="55" r="5" fill={fill} />

      {/* D-pad (left side) */}
      <rect x="28" y="57" width="14" height="5" rx="1" fill={highlight} />
      <rect x="32.5" y="52.5" width="5" height="14" rx="1" fill={highlight} />

      {/* Action buttons (right side) - 4 buttons in diamond */}
      <circle cx="65" cy="40" r="3.5" fill={highlight} />
      <circle cx="59" cy="46" r="3.5" fill={highlight} />
      <circle cx="71" cy="46" r="3.5" fill={highlight} />
      <circle cx="65" cy="52" r="3.5" fill={highlight} />
    </svg>
  );
};

export const GameController = React.memo(GameControllerBase);
